// // 默认配置
// import {  netConfig, settingConfig, themeConfig } from './default'
// // 自定义配置
// import customConfig from './customConfig'
//
// // 导出配置（自定义配置优先级高）
// export default Object.assign({}, netConfig, settingConfig, themeConfig, customConfig)

export const setupService = '/duoduo-service/setup-service/'
export const objectService = '/duoduo-service/object-service/'
export const duoduoenvService = '/duoduo-service/duoduoenv-service/'
export const weachatService = '/duoduo-service/'
export const ssoService = '/sso/'
export const testApi = '/test/'
